import { STORAGE_KEYS } from "@/hooks/auth-constants";

export type ThemePreference = "auto" | "light" | "dark";

export const THEME_SETTINGS_KEY = "theme" as const;

export const DEFAULT_THEME_PREFERENCE: ThemePreference = "auto";

const VALID: readonly ThemePreference[] = ["auto", "light", "dark"];

export function normalizeThemePreference(raw: unknown): ThemePreference {
  if (typeof raw === "string" && (VALID as readonly string[]).includes(raw)) {
    return raw as ThemePreference;
  }
  return DEFAULT_THEME_PREFERENCE;
}

export function resolveTheme(preference: ThemePreference): "light" | "dark" {
  if (preference === "dark") return "dark";
  if (preference === "light") return "light";
  if (typeof window === "undefined") return "light";
  return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}

export function applyThemeToDocument(resolved: "light" | "dark"): void {
  if (typeof document === "undefined") return;
  document.documentElement.classList.toggle("dark", resolved === "dark");
}

export function readThemePreferenceFromStorage(): ThemePreference | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEYS.THEME_PREFERENCE);
    if (typeof raw === "string" && (VALID as readonly string[]).includes(raw)) {
      return raw as ThemePreference;
    }
  } catch {
    /* ignore */
  }
  return null;
}

export function writeThemePreferenceToStorage(preference: ThemePreference): void {
  try {
    localStorage.setItem(STORAGE_KEYS.THEME_PREFERENCE, preference);
  } catch {
    /* ignore */
  }
}
